import { Directory } from "@/type";
import { NIcon } from "naive-ui";
import { h } from "vue";
import { InsertDriveFileOutlined, FolderFilled } from "@vicons/material";
function pathToFileName(path: string): string {
  const dirs = path.split("/");
  if (dirs[dirs.length - 1]) {
    return dirs[dirs.length - 1];
  }
  return dirs[dirs.length - 2];
}
export function isDir(path: string): boolean {
  return /.*\/$/.test(path);
}
function pathsToDirectory(rootPath = "", paths: string[] = []): Directory {
  const rxp = new RegExp(`^${rootPath}[^/]+/?$`);
  const _paths = paths.filter((path) => rxp.test(path));
  if (_paths.length === 0) {
    return [];
  }
  return _paths.map((path) => {
    if (isDir(path)) {
      return {
        key: path,
        label: pathToFileName(path),
        children: pathsToDirectory(path, paths),
        // @ts-ignore
        prefix: () =>
          h(NIcon, { size: 20 }, { default: () => h(FolderFilled) }),
      };
    }
    return {
      key: path,
      label: pathToFileName(path),
      // @ts-ignore
      prefix: () =>
        h(NIcon, { size: 20 }, { default: () => h(InsertDriveFileOutlined) }),
    };
  });
}
export default pathsToDirectory;
